// Contact & conversion constants — kept exact per NAP requirements.
export const WA_NUMBER = "527775557088";
export const PHONE_DISPLAY = "777 555 7088";
export const PHONE_TEL = "7775557088";
export const EMAIL = "contactocesma@gmail.com";
export const ADDRESS = "Lisboa 9, Col. Burgos, Cuernavaca, Morelos";

export const waLink = (text) =>
  `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(text)}`;
